import { Injectable } from "@angular/core";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { PlessHttp } from "src/app/shared/http/pless-http.service";
import { KYMW7100Model } from "../kymw7100.model";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { BundleCatalogModel } from "../vo/bundle-catalog.model";

export type GetBundleCatalogRoundInfoResponse = {
  BundleCatalogRoundId: string,
  MediumType: string,
  MediumName: string,
  StartOrderCode: string,
  EndOrderCode: string,
  StartDelivCatalogId: string,
  EndDelivCatalogId: string,
  BundleCatalogRoundName: string,
  BundleCatalogRoundCode: string,
  EndDelivCatalogEndDate: string,
}[];

/**
 * 束ね企画回情報を取得するサービス
 *
 * @export GetBundleCatalogRoundInfoService
 * @class GetBundleCatalogRoundInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetBundleCatalogRoundInfoService extends PlessJsonResponderSub<GetBundleCatalogRoundInfoResponse> {
  private model: KYMW7100Model;
  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetBundleCatalogRoundInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({});
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetBundleCatalogRoundInfoService
   */
  execute(model: KYMW7100Model) {
    this.model = model;
    this.send('getBundleCatalogRoundInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ 
   * @memberof GetBundleCatalogRoundInfoService 
   */
  success(data: GetBundleCatalogRoundInfoResponse) {
    this.model.bundleCatalogList = data.map(bc => new BundleCatalogModel(
      bc.BundleCatalogRoundId,
      bc.MediumType,
      `${bc.MediumType}:${bc.MediumName}`,
      bc.StartOrderCode,
      bc.EndOrderCode,
      bc.StartDelivCatalogId,
      bc.EndDelivCatalogId,
      bc.BundleCatalogRoundName,
      bc.BundleCatalogRoundCode,
      bc.EndDelivCatalogEndDate
    ));
  }
} 